import { useState } from "react";
import { getConfig } from "site-config";
import { fetchJSON } from "lib/fetch";
import type { TMerchantOrganization } from "models/new/merchant-organization";

import { TAPIResponse } from "../../types";
import { API_STATES } from "../../helpers";

type TUseFetchOrganizationHookParams = {
    organizationId: string;
};

type TUseFetchOrganizationParams = {
    storeName: string;
    email: string;
    phoneNumber: string;
};

export type TFetchOrganizationResponse = {
    organization: TMerchantOrganization;
};

export const useFetchOrganization = ({ organizationId }: TUseFetchOrganizationHookParams) => {
    const [state, setState] = useState<TAPIResponse<TFetchOrganizationResponse, { error: any; message: string }>>(
        API_STATES.default,
    );
    const APIStates = API_STATES.getStates(setState);

    const fetchOrganization = (params: TUseFetchOrganizationParams) => {
        const URL = `${getConfig().MERCHANT_ORGANIZATION_URL}/organizations/${organizationId}`;

        APIStates.pending();

        fetchJSON<TFetchOrganizationResponse>(URL, {
            method: "PUT",
            body: JSON.stringify({
                name: params.storeName,
                email: params.email,
                phone: params.phoneNumber,
                addressUpdateIntent: "ADDRESS_UPDATE_INTENT_IGNORE_IF_EMPTY",
            }),
        })
            .then(APIStates.success)
            .catch((error) => APIStates.error({ message: error }));
    };

    return {
        data: state.data,
        error: state.error,
        isLoading: state.isLoading,
        loaded: state.loaded,
        fetchOrganization,
    };
};
